import { render, staticRenderFns } from "./OpeningHoursForm.vue?vue&type=template&id=31a9884b"
import script from "./OpeningHoursForm.vue?vue&type=script&lang=js"
export * from "./OpeningHoursForm.vue?vue&type=script&lang=js"
import style0 from "./OpeningHoursForm.vue?vue&type=style&index=0&id=31a9884b&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31a9884b')) {
      api.createRecord('31a9884b', component.options)
    } else {
      api.reload('31a9884b', component.options)
    }
    module.hot.accept("./OpeningHoursForm.vue?vue&type=template&id=31a9884b", function () {
      api.rerender('31a9884b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/extras/offcanvas/OpeningHoursForm.vue"
export default component.exports